import React from "react";
import { Text, Button } from "@mantine/core";

interface NoSegmentationBlocksProps {
  onCreateNew: () => void;
}

export const NoSegmentationBlocks: React.FC<NoSegmentationBlocksProps> = ({
  onCreateNew,
}) => (
  <div className="empty-state">
    <div className="empty-state-container">
      <Text className="empty-state-heading" style={{ width: "initial" }}>
        No segmentation blocks
      </Text>
      <Text className="empty-state-paragraph">
        Block EWA advances for employees in specific segments. Blocks remain
        active until manually deactivated.
      </Text>

      <Button
        onClick={onCreateNew}
        type="button"
        variant="filled"
        className="btn-text"
        color="jem-theme"
      >
        Create New
      </Button>
    </div>
  </div>
);

export default NoSegmentationBlocks;
